import { render, staticRenderFns } from "./app-version.vue?vue&type=template&id=3a11e69c&"
import script from "./app-version.vue?vue&type=script&lang=ts&"
export * from "./app-version.vue?vue&type=script&lang=ts&"
import style0 from "./app-version.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports